<template>
  <div>
    <h1>What I use...</h1>

    <div class="container">
      <div>
        <p style="font-weight: bold">Computers</p>

        <ul>
          <li>Mac Studio M3 Ultra with 96GB RAM for local inference experiments</li>
          <li>MacBook Air M5 Base model with 16GB RAM</li>
          <li>MacMini - The base model M4 with 16GB RAM</li>
					<li>Asus G16 Strix 13980HX with RTX4070</li>
          <li>PC - 10th Gen intel 10900K with 64GB RAM and a 7900XTX. Windows for Gaming</li>
          <li>SFF Build - Ryzen 5600X with 32GB RAM and a 2070 Super. Running Fedora Linux</li>
        </ul>

        <p></p>

        <p style="font-weight: bold">Software</p>

        <ul>
          <li><a href="https://www.jetbrains.com/">Jetbrains</a> IDEs. I use IntelliJ, PyCharm, DataGrip and DataSpell mainly.</li>
          <li><a href="https://code.visualstudio.com/">VSCode</a> - still has the best devcontainer support</li>
        </ul>

        <p></p>

        <p style="font-weight: bold">Mobile Phones and Tablets</p>
        <ul>
          <li>iPhone 15 Plus</li>
          <li>Apple iPad Pro 2018 with Apple Pencil. I use this for sketching out ideas. It is a great device!</li>
          <li>Apple iPad 6th Generation with Apple Pencil.</li>
          <li>Lots of older iPhones (dev devices :))</li>
        </ul>

        <p></p>

        <p style="font-weight: bold">Misc stuff</p>
        <ul>
          <li>Benq 32" Programming Monitor</li>
          <li>Razer Basilisk.</li>
          <li>Lofree Flow (US Layout)</li>
          <li>Obsbot Webcam</li>
          <li>Bowers and Wilkins Px7 S3 Headphones</li>
          <li><a href="https://destore.hermanmiller.com/products/embody-gaming-chair">Hermann Miller Embody</a> - Awesome chair</li>
          <li>Raspberry Pis: 1, 4 & Pi Zero W. Used for various projects, like home automation, Nexus etc.</li>
        </ul>

        <p>
        </p>

        <PageFooter footer-align="left"/>
      </div>
    </div>

  </div>
</template>

<script>
  import PageFooter from '../components/PageFooter.vue'

  export default {
    name: "UsesView",
    components: {
        PageFooter
    }
  }
</script>

<style scoped>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container div {
    width: 600px;
    height: 400px;
    text-align: left
  }

  p {
    text-align: left;
    margin-bottom: 10px;
  }
</style>
